import type { Block, Screen } from './types'

import { ACCESS_SCREENS } from './screens/access'
import { CONFIGURATION_SCREENS } from './screens/configuration'
import { CONTENT_SCREENS } from './screens/content'
import { CUSTOMERS_SCREENS } from './screens/customers'
import { DASHBOARD_SCREENS } from './screens/dashboard'
import { HANDLES_SCREENS } from './screens/handles'
import { LEDGER_SCREENS } from './screens/ledger'
import { MONEY_SCREENS } from './screens/money'
import { ONBOARDING_SCREENS } from './screens/onboarding'
import { PLATFORM_SCREENS } from './screens/platform'
import { PRICING_SCREENS } from './screens/pricing'
import { PROVIDERS_SCREENS } from './screens/providers'
import { RECOGNITION_SCREENS } from './screens/recognition'
import { REFERRALS_SCREENS } from './screens/referrals'
import { REPORTING_SCREENS } from './screens/reporting'
import { RISK_SCREENS } from './screens/risk'
import { STATEMENTS_SCREENS } from './screens/statements'
import { STOREFRONT_SCREENS } from './screens/storefront'
import { SUPPORT_SCREENS } from './screens/support'

export * from './types'
export { DEFAULT_INSP } from './inspector'

/** Every screen the console knows about, keyed by the id the nav uses. */
export const SCREENS: Readonly<Record<string, Screen>> = {
  ...DASHBOARD_SCREENS,
  ...CUSTOMERS_SCREENS,
  ...ONBOARDING_SCREENS,
  ...MONEY_SCREENS,
  ...LEDGER_SCREENS,
  ...RECOGNITION_SCREENS,
  ...RISK_SCREENS,
  ...HANDLES_SCREENS,
  ...PRICING_SCREENS,
  ...REFERRALS_SCREENS,
  ...PROVIDERS_SCREENS,
  ...STOREFRONT_SCREENS,
  ...REPORTING_SCREENS,
  ...STATEMENTS_SCREENS,
  ...CONTENT_SCREENS,
  ...CONFIGURATION_SCREENS,
  ...PLATFORM_SCREENS,
  ...ACCESS_SCREENS,
  ...SUPPORT_SCREENS,
}

/** Falls back to the dashboard, matching the prototype's `screen()`. */
export function screenFor(id: string): Screen {
  return SCREENS[id] ?? (SCREENS['dashboard'] as Screen)
}

/**
 * The blocks visible right now: a tabbed screen shows its screen-level blocks
 * followed by the active tab's. Verbatim from the prototype's `activeBlocks`.
 */
export function activeBlocks(screen: Screen, tab: number): readonly Block[] {
  if (screen.tabs !== undefined && screen.tabs.length > 0) {
    const active = screen.tabs[Math.min(tab, screen.tabs.length - 1)]
    return [...(screen.blocks ?? []), ...(active?.blocks ?? [])]
  }
  return screen.blocks ?? []
}
